exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".member-free-tag[data-v-4a2a2b69]{color:#85673d;font-size:12px;background:#f3d3a6;border-radius:4px;width:60px;height:22px;line-height:22px;text-align:center}", ""]);

// exports
